import { Component, inject, Inject } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TrailPropertiesService } from '../../service/trail-properties.service';
import { TrailDocumentModification } from '../../dto/trail-document-modification';
import { BoolDto } from '../../../../common/dto/bool-dto';

@Component({
  selector: 'dpi-trail-document-modification-detail',
  imports: [MatInputModule, MatFormFieldModule, MatSelectModule, FormsModule, MatButtonModule, MatIconModule, MatTooltipModule, MatDialogModule],
  templateUrl: './trail-document-modification-detail.component.html',
  styleUrl: './trail-document-modification-detail.component.scss'
})
export class TrailDocumentModificationDetailComponent {
  readonly dialogRef = inject(MatDialogRef<TrailDocumentModificationDetailComponent>);
  trailDocumentModification: TrailDocumentModification;
  isToUpdate: boolean;
  isToDelete: boolean;
  
  testedStates: BoolDto[];
  tested: BoolDto;

  trailUpdatedStates: BoolDto[];
  trailUpdated: BoolDto;

  constructor(@Inject(MAT_DIALOG_DATA) public data: TrailDocumentModification, private trailPropertiesService: TrailPropertiesService) {
    this.trailDocumentModification = data;
    this.isToUpdate = false;
    this.isToDelete = false;

    this.testedStates = this.trailPropertiesService.getAllTrialBinaryStates();
    this.tested = this.trailPropertiesService.getTrialSetupBinaryState(this.testedStates, data.tested);
    
    this.trailUpdatedStates = this.trailPropertiesService.getAllTrialBinaryStates();
    this.trailUpdated = this.trailPropertiesService.getTrialSetupBinaryState(this.trailUpdatedStates, data.trail_updated);
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onUpdateClick() {
    this.trailDocumentModification.tested = this.tested.state;
    this.trailDocumentModification.trail_updated = this.trailUpdated.state;
    this.isToUpdate = true;
  }

  onDeleteClick() {
    this.isToDelete = true;
    this.dialogRef.close();
  }

}
